import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-garantie-bareme',
  templateUrl: './detail-garantie-bareme.component.html',
  styleUrls: ['./detail-garantie-bareme.component.scss']
})
export class DetailGarantieBaremeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
